module.exports = {"210903001":"兴隆街道","210903002":"中兴街道","210903003":"益民街道","210903004":"新发街道","210903101":"长营子蒙古族镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210903.json
// module id = 517
// module chunks = 0